// Revisado: 2025-12-18 [I18n Scan]
import React from 'react';
import { useAuth } from '../../context/AuthContext';

import { useTranslation } from 'react-i18next';

const UserProfile = () => {
    const { t } = useTranslation();
    const { user, isAdmin } = useAuth();

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center gap-4 mb-8">
                <div className="w-20 h-20 rounded-full bg-primary-green flex items-center justify-center text-white text-3xl font-bold">
                    {user?.name?.charAt(0).toUpperCase() || 'U'}
                </div>
                <div>
                    <h2 className="text-2xl font-bold text-gray-800">{user?.name}</h2>
                    <p className="text-gray-500">{user?.email}</p>
                </div>
            </div>

            <div className="grid grid-cols-1 gap-6">
                <div className="p-4 bg-gray-50 rounded-lg border border-gray-100">
                    <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">{t('UserProfile.label_user_id')}</label>
                    <p className="text-gray-900 font-mono">{user?.user_id}</p>
                </div>

                <div className="p-4 bg-gray-50 rounded-lg border border-gray-100">
                    <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">{t('UserProfile.label_role')}</label>
                    <div className="flex items-center gap-2">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${isAdmin() ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800'
                            }`}>
                            {isAdmin() ? t('UserProfile.role_admin') : t('UserProfile.role_standard')}
                        </span>
                    </div>
                </div>

                <div className="p-4 bg-gray-50 rounded-lg border border-gray-100">
                    <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">{t('UserProfile.label_status')}</label>
                    <span className="text-green-600 font-medium flex items-center gap-1">
                        <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                        {t('UserProfile.status_active')}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default UserProfile;
// Revisado: 2025-12-18 I18n Updated
